import React from "react";
import { useNavigate} from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useSelector } from 'react-redux';
import {
  useGetProfileDataQuery,
} from "../slices/getqueries/getqueriesApi";
import Skeleton from '@mui/material/Skeleton';

const Profile = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const { clientId } = userInfo;
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };
  const {
    data: profileData,
    isLoading,
    isSuccess,
    error
  } = useGetProfileDataQuery({ clientname: clientId}, { refetchOnMountOrArgChange: true });
  return (
    <div>
      <div className="flex items-center gap-3 mb-6 cursor-pointer" >
        <FaArrowLeftLong className="w-10 h-10 text-gray-700 hover:text-black transition" onClick={handleBack}/>
        <h2 className="text-[24px] font-semibold text-gray-800">Profile</h2>
      </div>

      <div className="bg-white rounded-xl shadow p-8 w-full">

  <div className="flex items-center mb-6">
  {isLoading ? (
    <>
      <Skeleton variant="circular" width={96} height={96} />
      <div className="ml-4">
        <Skeleton variant="text" width={160} height={28} />
        <Skeleton variant="text" width={120} height={22} />
      </div>
    </>
  ) : error ? (
    <>
      <div className="w-24 h-24 bg-blue-100 text-[#204887] rounded-full flex items-center justify-center text-[35px] font-[400]">
        {profileData?.client_id?.[0] || "-"}
      </div>
      <div className="ml-4">
        <div className="text-[20px] font-[600] text-gray-800">
          {profileData?.client_id || "-"}
        </div>
        <div className="text-[16px] font-[400] text-gray-500">
          #{profileData?.org_application_id || "-"}
        </div>
      </div>
    </>
  ) : (
    <>
      <div className="w-24 h-24 bg-blue-100 text-[#204887] rounded-full flex items-center justify-center text-[35px] font-[400]">
        {profileData?.client_id?.[0] || "-"}
      </div>
      <div className="ml-4">
        <div className="text-[20px] font-[600] text-gray-800">
          {profileData?.client_id || "-"}
        </div>
        <div className="text-[16px] font-[400] text-gray-500">
          #{profileData?.org_application_id || "-"}
        </div>
      </div>
    </>
  )}
</div>
  {isLoading ? (
  [...Array(5)].map((_, i) => (
    <div key={i} className="flex flex-col gap-[10px] w-full">
      <Skeleton variant="text" width={150} height={20} />
      <Skeleton variant="rectangular" width="100%" height={45} />
    </div>
  ))
) : (
  <>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-6">
    <InputField label="Organization Name" value={profileData?.client_name || "-"} />
    <InputField label="Organization Application ID" value={profileData?.org_application_id || "-"} />
    <InputField label="Email ID" value={profileData?.email || "-"} />
    <InputField label="Tenant Name" value={profileData?.tenant_name || "-"} />
    <InputField label="Resource URI" className="md:col-span-2" value={profileData?.resource_url || "-"} />
    </div>
  </>
)}

</div>

    </div>
  );
};

const InputField = ({ label, value = "", className = "" }) => (
  <div className={`flex flex-col gap-[10px] ${className} w-full`}>
    <label className="text-[14px] font-medium text-gray-800">{label}</label>
    <input
      type="text"
      value={value}
      disabled
      className="w-full h-[45px] px-[24px] py-[16px] rounded-[12px] border border-gray-300 text-gray-700 bg-[#EFF5FF] focus:outline-none text-[16px]"
    />
  </div>
);


export default Profile;
